/* eslint-disable no-param-reassign */
import moment from 'moment'
import qs from 'qs'
import zyTrack from './track'

const util = {
  /**
   * @param {itemId,shopId,startDate,endDate} props
   */
  jumpToTaobao(props) {
    const { itemId } = props
    const url = itemId ? `/itemDetail/taobaoLive?${qs.stringify(props)}` : `/shopDetail/live?${qs.stringify(props)}`
    window.open(url)
  },
  jumpToJhs(props) {
    const { itemId } = props
    const url = itemId ? `/itemDetail/marketing/ju?${qs.stringify(props)}` : `/shopDetail/marketing?${qs.stringify(props)}`
    window.open(url)
  },
  jumpToDy(props) {
    const { itemId } = props
    const url = itemId ? `/douyin/itemDetail?${qs.stringify(props)}` : `/shopDetail/douyin?${qs.stringify(props)}`
    window.open(url)
  },
  /**
   *
   * @param {[]} config
   * @param {[][]} data
   * @param {string} fileName
   * @param {function} onProgress
   */
  // async exportExcelByMultipleSheet(config, data, fileName) {
  //   const workbook = new Excel.Workbook()
  //   for (let i = 0; i < data.length; i++) {
  //     // eslint-disable-next-line no-await-in-loop
  //     await createSheet(workbook, config[i], data[i])
  //   }
  //   const buffer = await workbook.xlsx.writeBuffer()
  //   util.buffer2File(buffer, `${fileName}.xlsx`)
  // },
  /**
   * 导出Excel
   * @example
   * let config={name:'工作簿1',column:[
   *    { name:'图片', type:'image', fieldName:'url' },
   *    { name:'金额', fieldName:'price', convert(fieldName,row){ return row[fieldName]/100} }
   * ]}
   * 兼容导出列表配置，fieldName可以替换为dataIndex，e.g:{ name:'图片', type:'image', dataIndex:'url' },
   * 兼容导出列表的配置，convert 可以被替换为render，但是导出列表的render方法第一个入参为record[fieldName]，而不是field，所以不可以用【
   *
   * const data=[{url:'xxxxx',price:2000},{url:'xxxxx',price:3000}]
   * exportExcel(config,data,'导出的文件名.xlsx',(row,total)=>console.log(`当前进度 ${row}/${total}`))
   * @param {*} config {}
   * @param {*} data
   * @param {*} fileName
   * @param {*} onProgress
   */
  // async exportExcel(config, data, fileName, onProgress = () => { }) {
  //   const workbook = new Excel.Workbook()
  //   const sheet = workbook.addWorksheet(config.name)
  //   const titles = []
  //   config.column.forEach((m, i) => {
  //     titles.push(m.name)
  //     sheet.getColumn(i + 1).width = m.width
  //   })
  //   sheet.addRow(titles)
  //   for (let i = 0; i < data.length; i++) {
  //     const m = data[i]
  //     const row = []
  //     for (let j = 0; j < config.column.length; j++) {
  //       const col = config.column[j]
  //       let cell = ''
  //       const convert = col.convert || col.render
  //       if (typeof convert === 'function') {
  //         cell = convert(col.fieldName || col.dataIndex, m, i)
  //       } else {
  //         cell = lodash.get(m, col.fieldName || col.dataIndex, '')
  //       }
  //       if (col.type === 'image') {
  //         try {
  //           // eslint-disable-next-line no-await-in-loop
  //           const myBase64Image = await util.getBase64Image(cell)
  //           const imgId = workbook.addImage({
  //             base64: myBase64Image,
  //             extension: 'png',
  //           })
  //           sheet.addImage(imgId, {
  //             tl: { col: j, row: i + 1 },
  //             br: { col: j + 1, row: i + 2 }
  //           })
  //         } catch (e) {
  //           console.error(e)
  //         }
  //       } else if (col.type === 'link') {
  //         row[j] = { text: cell, hyperlink: cell, tooltip: cell }
  //       } else {
  //         row[j] = cell
  //       }
  //     }
  //     sheet.addRow(row).height = config.rowHeight
  //     onProgress(i, data.length)
  //   }
  //   const buffer = await workbook.xlsx.writeBuffer()
  //   util.buffer2File(buffer, `${fileName}.xlsx`)
  //   util.track('export', { ...util.getTrackModule(), name })
  // },
  /**
   * 把内存buffer转换为下载文件
   * @param {Buffer} buffer
   * @param {string} fileName
   * @param {string} fileName
   */
  buffer2File(buffer, fileName, type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8') {
    const blob = new Blob([buffer], { type })
    const a = document.createElement('a')
    a.download = fileName
    a.href = URL.createObjectURL(blob)
    a.click()
    setTimeout(() => {
      URL.revokeObjectURL(a.href)
    }, 40000)
  },
  async downloadOssImageByUrl(url, name) {
    const fileName = name || url.split('/').pop()
    const userAgent = navigator.userAgent.toLocaleLowerCase()
    const a = document.createElement('a')
    a.download = fileName
    if (userAgent.match(/tencenttraveler/) || userAgent.match(/qqbrowse/)) {
      a.href = `${url.replace('zhiyi-web.oss-cn-hangzhou.aliyuncs.com', 'zhiyi-web.zhiyitech.cn').replace('zhiyi-image.oss-cn-hangzhou.aliyuncs.com', 'zhiyi-image-cdn.zhiyitech.cn')}?response-content-type=application/octet-stream`
    } else {
      a.href = await this.getBase64Image(`${url}?${Date.now()}`)
    }
    a.click()
    URL.revokeObjectURL(a.href)
  },
  async downloadImageByUrl(url, name) {
    const fileName = name || url.split('/').pop()
    const a = document.createElement('a')
    a.download = fileName
    a.href = await this.getBase64Image(`${url}?${Date.now()}`)
    a.click()
    URL.revokeObjectURL(a.href)
  },
  getBase64Image(url) {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const img = new Image()
      img.crossOrigin = 'Anonymous'
      img.addEventListener('load', () => {
        canvas.width = img.naturalWidth
        canvas.height = img.naturalHeight
        ctx.drawImage(img, 0, 0)
        resolve(canvas.toDataURL('image/jpeg'))
        canvas.remove()
        img.remove()
      })
      img.addEventListener('error', () => reject(new Error('图片加载失败')))
      img.src = url
    })
  },
  getImage(object) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this
    return new Promise((resolve, reject) => {
      let img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = () => {
        that.createCanvas(img)
        that.canvas.toBlob((blob) => {
          if (object.blob === null) {
            object.blob = blob
            that.loaded.push(object)
          }
          img.onload = null
          img = null
          resolve(object)
        }, 'image/png')
      }
      img.onerror = () => {
        img.onerror = null
        img = null
        object.blob = null
        reject(object)
      }
      img.src = object.url
      if (img.complete || img.complete === undefined) {
        img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=='
        img.src = object.url
      }
    })
  },
  isExpire30(date) {
    const diffDay = moment(date).diff(moment(new Date()), 'days')
    return diffDay < 30
  },
  getLimitDate(date) {
    let result = ''
    const diffDay = moment(date).diff(moment(new Date()), 'days')
    if (diffDay < 30) result = '（不足30天）'
    if (diffDay < 7) result = '（不足7天）'
    // if (diffDay < 1) result = '（今天）'
    if (diffDay < 0) result = '（已过期）'
    return result
  },
  /**
   * 根据时间（秒）转换成友好时间如:20小时49分
   * @param {number} timeSpan 秒数
   */
  timeSpanFormat(timeSpan) {
    const h = Math.floor(timeSpan / 60 / 60)
    const m = Math.floor(timeSpan / 60) % 60
    return h >= 1 ? `${h}小时${m}分` : `${m}分`
  },
  getTimeSpanForma(start, end) {
    const mstart = moment(start)
    const mend = moment(end)
    const timeSpan = mend.diff(mstart) / 1000
    return this.timeSpanFormat(timeSpan)
  },
  getFormatDate(date, formatter = 'YYYY-MM-DD HH:mm:ss') {
    if (!date) return '-'
    return moment(date).format(formatter)
  },
  deleteAllCookies() {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i]
      const eqPos = cookie.indexOf('=')
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
      this.setCookie(name, '', '')
    }
  },
  // 获取URL参数
  getUrlParam(name) {
    const query = window.location.search.substring(1)
    const params = query.split('&')
    for (let i = 0; i < params.length; i++) {
      const tmp = params[i].split('=')
      if (tmp[0] === name) return tmp[1]
    }
    return ''
  },
  /**
   * price/number格式，默认除以100
   * accuracy === 1 表示件数个数 非价格
   * accuracy === 100 表示价格单位元
   * accuracy === 1000000 表示价格单位万元
   * */
  formatNumber(number, accuracy = 100) {
    if (typeof number === 'number') {
      return accuracy === 1 ? number : (number / accuracy).toFixed(2)
    }
    return '暂无'
  },

  getAddDayCountDate(lastMonitorDate, AddDayCount) {
    const dd = new Date(lastMonitorDate)
    dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期
    const y = dd.getFullYear()
    const m = dd.getMonth() + 1 < 10 ? `0${dd.getMonth() + 1}` : dd.getMonth() + 1
    const d = dd.getDate() < 10 ? `0${dd.getDate()}` : dd.getDate()
    return `${y}-${m}-${d}`
  },

  setCookie(cName, value, expiredays) {
    const exdate = new Date()
    exdate.setDate(exdate.getDate() + expiredays)
    document.cookie = `${cName}=${escape(value)}${(expiredays == null) ? '' : `;expires=${exdate.toGMTString()}`}`
  },
  getCookie(cName) {
    if (document.cookie.length > 0) {
      const cookies = document.cookie.split(';')
      const cookieObj = {}
      cookies.forEach((m) => {
        const tmp = m.split('=')
        cookieObj[tmp[0].trim().replace('"', '')] = tmp[1]
      })
      return cookieObj[cName] ? unescape(cookieObj[cName]) : ''
    }
    return ''
  },

  serializeJSONString(JSONStr, divider = ';') {
    const JSONObj = JSON.parse(JSONStr)
    if (!JSONStr || !JSONObj || typeof JSONObj !== 'object') {
      return JSONStr
    }
    return Object.keys(JSONObj).map(key => `${key}:${JSONObj[key]}`).join(divider)
  },
  judgeDateIfInRecent30Days(date) {
    if (date instanceof Date) {
      const dateTime = date.getTime()
      let startDate = new Date()
      startDate.setDate(startDate.getDate() - 30)
      startDate = startDate.getTime()
      const endDate = new Date().getTime()
      return dateTime > startDate && dateTime < endDate
    }
    return false
  },
  getScrollParent(ref) {
    if (!ref) return undefined
    if (!ref.parentElement) return window
    if (ref.parentElement.scrollHeight > ref.parentElement.clientHeight) {
      if (ref.parentElement.className === 'app') { return window }
      return ref.parentElement
    }
    return this.getScrollParent(ref.parentElement)
  },
  track(name, params, callback) {
    zyTrack.send({ event: name, content: params, callback })
  },
  getTrackModule() {
    const res = {}
    const urlParams = qs.parse(location.search, { ignoreQueryPrefix: true })
    // 监控中心模块
    if (document.title.startsWith('监控')) {
      // const urlParams = qs.parse(location.search, { ignoreQueryPrefix: true })
      const titles = document.title.split('-')
      res.module1 = '监控中心'
      res.module2 = titles?.[0].replace('监控', '')
      res.module3 = titles?.[1]
      if (document.querySelector('.monitor-new-slogan-info-wrap > .slogan-title > .hot-tabs >.tab.active')?.innerText) {
        res.module4 = document.querySelector('.monitor-new-slogan-info-wrap > .slogan-title > .hot-tabs >.tab.active')?.innerText
      } else if (document.querySelector('.monitor-new-slogan-info-wrap > .slogan-title > .new-tabs >.tab.active')?.innerText) {
        res.module4 = document.querySelector('.monitor-new-slogan-info-wrap > .slogan-title > .new-tabs >.tab.active')?.innerText
      } else if (urlParams.subType === 'trend') {
        res.module4 = '热销商品'
      }
    } else if (document.title.startsWith('商品详情')) { // 商品详情
      const titles = document.title.split('-')
      res.module1 = '商品详情'
      res.module2 = titles?.[1]
    } else if (document.title.startsWith('商品')) { // 商品库模块
      const titles = document.title.split('-')
      res.module1 = '商品库'
      res.module2 = titles?.[1]
    } else if (document.title.startsWith('找店铺')) { // 找店铺模块
      const titles = document.title.split('-')
      res.module1 = '找店铺'
      res.module2 = titles?.[1]
    } else if (document.title.startsWith('行业')) { // 行业洞察模块
      // const titles = document.title.split('-')
      res.module1 = '行业洞察'
      // res.module2 = titles?.[1]
      if (urlParams.type === 'category-insight') {
        const all = document.querySelectorAll('.content-content-warp > .title .menu')
        res.module2 = '市场洞察'
        res.module3 = '品类洞察'
        all.forEach((item) => {
          if (item.className === 'menu') {
            res.module4 = item?.innerText
          }
        })
      } else if (urlParams.type === 'property-insight') {
        const all = document.querySelectorAll('.content-content-warp > .title .menu')
        res.module2 = '市场洞察'
        res.module3 = '属性洞察'
        all.forEach((item) => {
          if (item.className === 'menu') {
            res.module4 = item?.innerText
          }
        })
      } else if (urlParams.type === 'brand-insight') {
        const all = document.querySelectorAll('.content-content-warp > .title .menu')
        res.module2 = '市场洞察'
        res.module3 = '品牌洞察'
        all.forEach((item) => {
          if (item.className === 'menu') {
            res.module4 = item?.innerText
          }
        })
      } else if (urlParams.type === 'price-insight') {
        const all = document.querySelectorAll('.content-content-warp > .title .menu')
        res.module2 = '市场洞察'
        res.module3 = '价格带洞察'
        all.forEach((item) => {
          if (item.className === 'menu') {
            res.module4 = item?.innerText
          }
        })
      } else if (urlParams.type === 'item-rank') {
        res.module2 = '行业排行'
        res.module3 = '商品'
      } else if (urlParams.type === 'shop-rank') {
        res.module2 = '行业排行'
        res.module3 = '店铺'
      } else if (urlParams.type === 'new-pre') {
        const all = document.querySelectorAll('.content-content-warp > .title .menu')
        res.module2 = '行业预售洞察'
        res.module3 = '新品预热'
        all.forEach((item) => {
          if (item.className === 'menu') {
            res.module4 = item?.innerText
          }
        })
      } else if (urlParams.type === 'full-pre') {
        const all = document.querySelectorAll('.content-content-warp > .title .menu')
        res.module2 = '行业预售洞察'
        res.module3 = '全款预售'
        all.forEach((item) => {
          if (item.className === 'menu') {
            res.module4 = item?.innerText
          }
        })
      } else if (urlParams.type === 'dis-pre') {
        const all = document.querySelectorAll('.content-content-warp > .title .menu')
        res.module2 = '行业预售洞察'
        res.module3 = '定金预售'
        all.forEach((item) => {
          if (item.className === 'menu') {
            res.module4 = item?.innerText
          }
        })
      } else if (urlParams.type === 'comparison') {
        res.module2 = '对比分析'
        res.module3 = document.querySelector('.analysis-header > .analysis-header-item.active')?.innerText
        res.module4 = document.querySelector('.analysis-tab > .active')?.innerText
      } else if (urlParams.type === 'keyword-analysis') {
        res.module2 = '关键词分析'
      } else if (!urlParams.type || urlParams.type === 'base') {
        res.module2 = '行业概览'
      }
    } else if (document.title.endsWith('关键词分析')) { // 竞店趋势模块
      const titles = document.title.split('-')
      res.module1 = titles?.[0]
      res.module2 = titles?.[1]
    } else if (document.title.startsWith('智能搜图')) { // 智能搜图模块
      res.module1 = '智能搜图'
    } else if (location.pathname === '/home') {
      res.module1 = '首页'
      res.module2 = document.querySelector('.find-lnk > .haokuan-title > .single-title.active')?.innerText
    } else if (location.pathname === '/dressSection/industry') {
      res.module1 = '连衣裙'
      res.module2 = '市场趋势'
      res.module3 = '新品速递'
    } else if (location.pathname === '/dressSection/goods') {
      res.module1 = '连衣裙'
      res.module2 = '精选商品'
      res.module3 = document.querySelector('.tab-bar>.title-panel>.tabs >.tab-item.active')?.innerText
    } else if (location.pathname === '/tShirtSection/industry') {
      res.module1 = 'T恤'
      res.module2 = '市场趋势'
      res.module3 = '新品速递'
    } else if (location.pathname === '/tShirtSection/goods') {
      res.module1 = 'T恤'
      res.module2 = '精选商品'
      res.module3 = document.querySelector('.tab-bar>.title-panel>.tabs >.tab-item.active')?.innerText
    } else if (location.pathname === '/sweaterSection/industry') {
      res.module1 = '卫衣'
      res.module2 = '市场趋势'
      res.module3 = '新品速递'
    } else if (location.pathname === '/sweaterSection/goods') {
      res.module1 = '卫衣'
      res.module2 = '精选商品'
      res.module3 = document.querySelector('.tab-bar>.title-panel>.tabs >.tab-item.active')?.innerText
    } else if (location.pathname === '/ranking/shop/hot') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-店铺榜'
      res.module3 = '销量榜'
      res.module4 = '热销榜'
    } else if (location.pathname === '/ranking/shop/surge') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-店铺榜'
      res.module3 = '销量榜'
      res.module4 = '飙升榜'
    } else if (location.pathname === '/ranking/shop/new') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-店铺榜'
      res.module3 = '销量榜'
      res.module4 = '新品榜'
    } else if (location.pathname === '/ranking/shop/hotSalesVolume') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-店铺榜'
      res.module3 = '销售额榜'
      res.module4 = '热销榜'
    } else if (location.pathname === '/ranking/shop/surgeSalesVolume') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-店铺榜'
      res.module3 = '销售额榜'
      res.module4 = '飙升榜'
    } else if (location.pathname === '/ranking/shop/newSalesVolume') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-店铺榜'
      res.module3 = '销售额榜'
      res.module4 = '新品榜'
    } else if (location.pathname === '/ranking/shop/collect') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-店铺榜'
      res.module3 = '收藏榜'
      res.module4 = '热门榜'
    } else if (location.pathname === '/ranking/shop/surgeCollect') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-店铺榜'
      res.module3 = '收藏榜'
      res.module4 = '飙升榜'
    } else if (location.pathname === '/ranking/shop/pre') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-店铺榜'
      res.module3 = '定金榜'
      res.module4 = '定金预售榜'
    } else if (location.pathname === '/ranking/live/hotShop') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-直播榜'
      res.module3 = '直播店铺榜'
      res.module4 = '热销榜'
    } else if (location.pathname === '/ranking/live/newShop') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-直播榜'
      res.module3 = '直播店铺榜'
      res.module4 = '上新榜'
    } else if (location.pathname === '/ranking/brand/goods') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-品牌'
      res.module3 = '销量榜'
      res.module4 = '热销商品榜'
    } else if (location.pathname === '/ranking/brand/surgeGoods') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-品牌'
      res.module3 = '销量榜'
      res.module4 = '飙升商品榜'
    } else if (location.pathname === '/ranking/brand/new') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-品牌'
      res.module3 = '销量榜'
      res.module4 = '上新商品榜'
    } else if (location.pathname === '/ranking/brand/goodsSalesVolume') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-品牌'
      res.module3 = '销售额榜'
      res.module4 = '热销商品榜'
    } else if (location.pathname === '/ranking/brand/surgeGoodsSalesVolume') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-品牌'
      res.module3 = '销售额榜'
      res.module4 = '飙升商品榜'
    } else if (location.pathname === '/ranking/brand/newSalesVolume') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-品牌'
      res.module3 = '销售额榜'
      res.module4 = '上新商品榜'
    } else if (location.pathname === '/ranking/hotword/hot') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-热词'
      res.module3 = '热词榜'
    } else if (location.pathname === '/ranking/hotword/taobao') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-热词'
      res.module3 = '热搜榜'
    } else if (location.pathname === '/ranking/hotword/rise') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-热词'
      res.module3 = '飙升榜'
    } else if (location.pathname === '/ranking/hotword/new') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-热词'
      res.module3 = '新增词'
    } else if (location.pathname === '/ranking/live/hotGoods') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-直播'
      res.module3 = '直播商品榜'
      res.module4 = '热销榜'
    } else if (location.pathname === '/ranking/live/newGoods') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-直播'
      res.module3 = '直播商品榜'
      res.module4 = '新品榜'
    } else if (location.pathname === '/ranking/live/hotBrand') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-直播'
      res.module3 = '品牌直播榜'
      res.module4 = '热销榜'
    } else if (location.pathname === '/ranking/live/newBrand') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-直播'
      res.module3 = '品牌直播榜'
      res.module4 = '新品榜'
    } else if (location.pathname === '/itemDetail/overview/sku') {
      res.module1 = '商品详情'
      res.module2 = '基础分析'
      res.module3 = 'SKU分析'
    } else if (location.pathname === '/shopDetail/recommend') {
      res.module1 = '店铺详情'
      res.module2 = '相似推荐'
    } else if (location.pathname === '/shopDetail/items/new') {
      res.module1 = '店铺详情'
      res.module2 = '店铺商品'
      res.module3 = '上新'
      res.module4 = document.querySelector('.title-panel > .tabs > .tab-item.active')?.innerText
    } else if (location.pathname === '/shopDetail/items/pre') {
      res.module1 = '店铺详情'
      res.module2 = '店铺商品'
      res.module3 = '预售'
      res.module4 = document.querySelector('.title-panel > .tabs > .tab-item.active')?.innerText
    } else if (location.pathname === '/shopDetail/items/hot') {
      res.module1 = '店铺详情'
      res.module2 = '店铺商品'
      res.module3 = '热销'
      res.module4 = document.querySelector('.title-panel > .tabs > .tab-item.active')?.innerText
    } else if (location.pathname === '/shopDetail/items/all') {
      res.module1 = '店铺详情'
      res.module2 = '店铺商品'
      res.module3 = '全部'
    } else if (location.pathname === '/shopDetail/analysis') {
      res.module1 = '店铺详情'
      res.module2 = '店铺分析'
      res.module3 = document.querySelector('.title-panel > .tabs > .tab-item.active')?.innerText
      res.module4 = '热销商品'
    } else if (location.pathname === '/shopDetail/marketing') {
      res.module1 = '店铺详情'
      res.module2 = '营销分析'
      res.module3 = document.querySelector('.title-panel > .tabs > .tab-item.active')?.innerText
      res.module4 = '热销商品'
    } else if (location.pathname === '/shopDetail/live') {
      res.module1 = '店铺详情'
      res.module2 = '直播分析'
      res.module3 = document.querySelector('.title-panel > .tabs > .tab-item.active')?.innerText
    } else if (location.pathname.startsWith('/taobaoHostDetail')) {
      res.module1 = '达人详情'
      if (location.pathname.endsWith('/item')) {
        res.module2 = '带货列表'
      } else if (location.pathname.endsWith('/shop')) {
        res.module2 = '合作店铺'
      }
    } else if (location.pathname.startsWith('/taobaoLiveDetail')) {
      res.module1 = '直播详情'
      res.module2 = '带货列表'
    } else if (location.pathname.startsWith('/aiTestStyle/detail')) {
      res.module1 = '新品智测'
      res.module2 = document.querySelector('.tab > .tab-item.active')?.innerText
    } else if (location.pathname === '/ranking/goods/hot') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-商品'
      res.module3 = '销量榜'
      res.module4 = '热销榜'
    } else if (location.pathname === '/ranking/goods/surge') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-商品'
      res.module3 = '销量榜'
      res.module4 = '飙升榜'
    } else if (location.pathname === '/ranking/goods/new') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-商品'
      res.module3 = '销量榜'
      res.module4 = '新品榜'
    } else if (location.pathname === '/ranking/goods/hotSalesVolume') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-商品'
      res.module3 = '销量额榜'
      res.module4 = '热销榜'
    } else if (location.pathname === '/ranking/goods/surgeSalesVolume') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-商品'
      res.module3 = '销量额榜'
      res.module4 = '飙升榜'
    } else if (location.pathname === '/ranking/goods/newSalesVolume') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-商品'
      res.module3 = '销量额榜'
      res.module4 = '新品榜'
    } else if (location.pathname === '/ranking/goods/collect') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-店铺榜'
      res.module3 = '收藏榜'
      res.module4 = '热门榜'
    } else if (location.pathname === '/ranking/goods/surgeCollect') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-店铺榜'
      res.module3 = '收藏榜'
      res.module4 = '飙升榜'
    } else if (location.pathname === '/ranking/goods/pre') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-店铺榜'
      res.module3 = '定金榜'
      res.module4 = '定金预售榜'
    } else if (location.pathname === '/itemDetail/overview/base') {
      res.module1 = '商品详情'
    } else if (location.pathname === '/searchResult/good') {
      res.module1 = '搜索结果'
      res.module2 = '商品'
      res.module3 = urlParams.type == 'ai' ? '智能搜索' : '精确搜索'
    } else if (location.pathname === '/searchResult/shop') {
      res.module1 = '搜索结果'
      res.module2 = '店铺'
    } else if (location.pathname === '/shopDetail/comment') {
      res.module1 = '店铺详情'
      res.module2 = '评价分析'
      res.module3 = '评价商品榜'
    } else if (location.pathname === '/shopDetail/baseInfo') {
      res.module1 = '店铺详情'
      res.module2 = '竞店概览'
    } else if (location.pathname === '/rankDetail') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-热词'
      res.module3 = '热词详情'
    } else if (location.pathname === '/ranking/brand/hot') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-品牌'
      res.module3 = '销量榜'
      res.module4 = '热销品牌榜'
    } else if (location.pathname === '/ranking/brand/surge') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-品牌'
      res.module3 = '销量榜'
      res.module4 = '飙升品牌榜'
    } else if (location.pathname === '/ranking/brand/hotSalesVolume') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-品牌'
      res.module3 = '销售额榜'
      res.module4 = '热销品牌榜'
    } else if (location.pathname === '/ranking/brand/surgeSalesVolume') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-品牌'
      res.module3 = '销售额榜'
      res.module4 = '飙升品牌榜'
    } else if (location.pathname === '/ranking/brand/pre') {
      res.module1 = '排行榜'
      res.module2 = '排行榜-品牌'
      res.module3 = '定金榜'
      res.module4 = '定金预售榜'
    } else if (location.pathname === '/itemDetail/comments/analysis') {
      res.module1 = '商品详情'
      res.module2 = '口碑分析'
      res.module3 = '评价分析'
    } else if (location.pathname === '/itemDetail/comments/buyersShow') {
      res.module1 = '商品详情'
      res.module2 = '口碑分析'
      res.module3 = '买家秀'
    } else if (location.pathname === '/itemDetail/like/item') {
      res.module1 = '商品详情'
      res.module2 = '相似商品'
    }
    return res
  }
}

export default util
